/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./UserInfo.vue?vue&type=template&id=aeffcf1a"
import script from "./UserInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./UserInfo.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports